import { Heading, Box, Text, SimpleGrid, Icon, VStack } from "@chakra-ui/react";
import { NETWORK_USE_CASE_LIST } from "./constants";
import { SectionDivider } from "app/components/shared/SectionDivider";

const NetworkUseCases = () => {
  return (
    <VStack paddingX={8} data-cy="section-use-cases">
      <SectionDivider label="Ansible Network Engineering Use Cases" padding={"2rem 0"} />
      <Text textAlign="center">
        CloudMyLab offers some pre-built use cases, which you can turn per your Network
        Environment.
      </Text>
      <Box mt={6}>
        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 4, lg: 7 }}
          spacing={{ base: 4, sm: 6 }}
        >
          {NETWORK_USE_CASE_LIST.map((useCase, index) => {
            return (
              <VStack key={index} spacing={4}>
                <Box>
                  <Icon
                    as={useCase.icon}
                    color="brand.100"
                    fontSize={"80px"}
                    display="flex"
                    alignItems={"center"}
                  />
                </Box>
                <Heading textAlign={"center"} as={"h3"} fontSize={"md"}>
                  {useCase.name}
                </Heading>
              </VStack>
            );
          })}
        </SimpleGrid>
      </Box>
    </VStack>
  );
};

export default NetworkUseCases;
